import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import * as types from "@/store/types";
class BaseService {
  baseUrl: string = process.env.VUE_APP_BASE_URL;
  cndUrl: string = process.env.VUE_APP_CDN_URL;
  axios: AxiosInstance = axios.create();

  Get<T>(url: string, config?: AxiosRequestConfig | undefined): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      axios
        .get<T>(url, config)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
}

  Post<T>(
    url: string,
    data: any,
    config?: AxiosRequestConfig | undefined
  ): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      axios
        .post<T>(url, data, config)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }

  Put<T>(
    url: string,
    data: any,
    config?: AxiosRequestConfig | undefined
  ): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      axios
        .put<T>(url, data, config)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }

  Delete<T>(url: string, config?: AxiosRequestConfig | undefined): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      axios
        .delete<T>(url, config)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }

  GetQueryStringByObject(data: any): string {
    const items: string[] = Object.keys(data)
      .filter(key => key && data[key] && typeof data[key] !== "object")
      .map(key => key + "=" + data[key]);
    Object.keys(data)
      .filter(key => key && data[key] && typeof data[key] === "object")
      .forEach(key => {
        Object.keys(data[key])
          .filter(
            subkey =>
              subkey &&
              data[key][subkey] &&
              typeof data[key][subkey] !== "object"
          )
          .forEach(subkey =>
            items.push(key + "." + subkey + "=" + data[key][subkey])
          );
      });
    return items.join("&");
  }
}

class AuthenticatedService extends BaseService {
  axios: AxiosInstance = axios.create();

  constructor() {
    super();
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${window.localStorage.getItem(types.GLOBAL_USER_TOKEN)}`;
  }
}

class UnauthenticatedService extends BaseService {
  axios: AxiosInstance = axios.create();

  constructor() {
    super();
    axios.defaults.headers.common["Content-Type"] = "application/json";
  }
}

export { AuthenticatedService, UnauthenticatedService };
